export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] max-w-lg mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20film%20projector%20and%20soft%20glowing%20light%2C%20elegant%20home%20theater%20atmosphere%2C%20cozy%20entertainment%20space%2C%20rich%20amber%20and%20crimson%20tones%2C%20professional%20production%20feel%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=about-img&orientation=landscape"
                alt="关于私密视频平台"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="flex-1 order-1 lg:order-2 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              私密视频 · 让好内容触手可及
            </h2>
            <div className="space-y-3 text-sm text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              <p>
                私密视频是一个综合性的高清视频内容聚合平台，致力于为用户提供红桃视频、西瓜视频免费、小蓝视频、
                茄子视频、久久视频、芒果视频等优质品牌的视频内容一站式服务。我们聚合了海量影视资源，
                涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。
              </p>
              <p>
                平台自上线以来，始终坚持"高清不缓冲、免费即点即看"的服务理念，通过持续优化的播放技术和
                丰富的内容储备，已累计服务超过500万活跃用户。无论是热播大片还是冷门佳作，
                私密视频都能为您提供流畅的观影体验。
              </p>
              <p>
                我们与多家内容合作伙伴保持紧密协作，每日更新200余部影视资源，确保平台内容始终保持新鲜活力。
                未来，私密视频将继续拓展内容生态，为更多用户带来优质的免费观影服务。
              </p>
            </div>
            <div className="flex flex-wrap justify-center lg:justify-start gap-6 mt-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary-600">99.8%</div>
                <div className="text-xs text-foreground-500 mt-1">流畅播放率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}